import MenuList from "./MenuList";

function SubMenuList({ data, maxWidth }) {
  return (
    <>
      <div className="d-flex flex-gap-30">
        {data &&
          data?.map(({ id, heading, description, subMenu }) => (
            <div className={`flex-fill maxWidth ${maxWidth ? maxWidth : ""}`} key={id}>
              <h5 className="mega-title sub-menu-heading">{heading}</h5>
              <MenuList data={subMenu} className={"sub-menu-title"} />
            </div>
          ))}
      </div>
    </>
  );
}

export default SubMenuList;
